// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-conditions-container .listing-header {
  display: flex;
  place-content: center;
  align-items: center;
  padding: 0.0625rem 0 1.875rem 0;
}
.terms-conditions-container .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.terms-conditions-container {
  overflow: scroll;
  padding: 1.5rem 1.875rem 1.5rem 1.875rem;
}
.terms-conditions-container .heading-label {
  font: normal normal bold 1.125rem/27px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.terms-conditions-container .form-container .form-inputs {
  padding-bottom: 0.75rem;
}
.terms-conditions-container .form-container .form-inputs ion-item .country-code {
  display: none;
}
.terms-conditions-container .form-container .form-inputs ion-item.item-has-value .country-code,
.terms-conditions-container .form-container .form-inputs ion-item.item-has-focus .country-code {
  display: flex;
}
.terms-conditions-container .form-container .form-inputs ion-label {
  letter-spacing: 0 !important;
  color: var(--ion-color-secondary-black) !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  font-size: 0.75rem !important;
}

ion-select {
  width: 100%;
  font: normal normal 600 1rem/24px Noto Sans;
}

.company-address-div {
  width: 49.2%;
}

.company-address-class {
  display: flex;
  place-content: space-between;
}

ion-input,
ion-item {
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  font-size: 1rem;
  line-height: 1.3125rem;
}

ion-list {
  padding: 0;
}

.text-left {
  right: 0 !important;
  left: unset !important;
}

.text-right {
  left: 0 !important;
  right: unset !important;
}

ion-select.LTR::part(icon) {
  opacity: 1;
  color: transparent;
  margin-left: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

ion-select.RTL::part(icon) {
  opacity: 1;
  color: transparent;
  margin-right: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.arabic-label {
  direction: ltr !important;
  text-align: right !important;
}

.arabic-select::part(placeholder) {
  direction: ltr;
  text-align: right;
}

.date-div {
  align-items: center;
}

.terms-conditions-div .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.terms-conditions-div .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}

.terms-conditions-div {
  padding: 0 0.3125rem 0 0;
}

.terms-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.terms-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.terms-bottom-container .cancel:hover {
  font-weight: 600;
}
.terms-bottom-container .terms-button ion-button {
  --background: var(--ion-color-primary);
  width: 100px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.close-div {
  position: absolute;
  right: 0.3125rem;
  top: 0.3125rem;
}

::-webkit-scrollbar {
  width: 0.625rem;
}

.close-icon {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/terms-conditions/terms-conditions.component.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,+BAAA;AAAF;AAEE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAAH;;AAKA;EACC,yBAAA;AAFD;;AAKA;EACC,2BAAA;AAFD;;AAKA;EACC,gBAAA;EACA,wCAAA;AAFD;AAIC;EACC,gDAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAFF;AAME;EACC,uBAAA;AAJH;AAOI;EACC,aAAA;AALL;AAWI;;EACC,aAAA;AARL;AAYG;EACC,4BAAA;EACA,kDAAA;EACA,oCAAA;EACA,qBAAA;EACA,6BAAA;AAVJ;;AAgBA;EACC,WAAA;EACA,2CAAA;AAbD;;AAgBA;EACC,YAAA;AAbD;;AAgBA;EACC,aAAA;EACA,4BAAA;AAbD;;AAgBA;;EAEC,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;AAbD;;AAgBA;EACC,UAAA;AAbD;;AAgBA;EACC,mBAAA;EACA,sBAAA;AAbD;;AAgBA;EACC,kBAAA;EACA,uBAAA;AAbD;;AAgBA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,wEAAA;AAbD;;AAgBA;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;AAbD;;AAgBA;EACC,yBAAA;EACA,4BAAA;AAbD;;AAgBA;EACC,cAAA;EACA,iBAAA;AAbD;;AAgBA;EACC,mBAAA;AAbD;;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAdF;AAgBE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAdH;;AAmBA;EACC,wBAAA;AAhBD;;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;AAhBD;AAkBC;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AAhBF;AAkBE;EACC,gBAAA;AAhBH;AAqBE;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAnBH;;AAwBA;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;AArBD;;AAwBA;EACC,eAAA;AArBD;;AAwBA;EACC,eAAA;AArBD","sourcesContent":[".terms-conditions-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tplace-content: center;\n\t\talign-items: center;\n\t\tpadding: 0.0625rem 0 1.875rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.terms-conditions-container {\n\toverflow: scroll;\n\tpadding: 1.5rem 1.875rem 1.5rem 1.875rem;\n\n\t.heading-label {\n\t\tfont: normal normal bold 1.125rem /27px Noto Sans;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n\n\t.form-container {\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 0.75rem;\n\n\t\t\tion-item {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-item.item-has-value,\n\t\t\tion-item.item-has-focus {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-label {\n\t\t\t\tletter-spacing: 0 !important;\n\t\t\t\tcolor: var(--ion-color-secondary-black) !important;\n\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\topacity: 1 !important;\n\t\t\t\tfont-size: 0.75rem !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\nion-select {\n\twidth: 100%;\n\tfont: normal normal 600 1rem /24px Noto Sans;\n}\n\n.company-address-div {\n\twidth: 49.2%;\n}\n\n.company-address-class {\n\tdisplay: flex;\n\tplace-content: space-between;\n}\n\nion-input,\nion-item {\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tfont-size: 1rem;\n\tline-height: 1.3125rem;\n}\n\nion-list {\n\tpadding: 0;\n}\n\n.text-left {\n\tright: 0 !important;\n\tleft: unset !important;\n}\n\n.text-right {\n\tleft: 0 !important;\n\tright: unset !important;\n}\n\nion-select.LTR::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-left: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\nion-select.RTL::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-right: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.arabic-label {\n\tdirection: ltr !important;\n\ttext-align: right !important;\n}\n\n.arabic-select::part(placeholder) {\n\tdirection: ltr;\n\ttext-align: right;\n}\n\n.date-div {\n\talign-items: center;\n}\n\n.terms-conditions-div {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\t}\n}\n\n.terms-conditions-div {\n\tpadding: 0 0.3125rem 0 0;\n}\n\n.terms-bottom-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t.cancel {\n\t\tfont-weight: 400;\n\t\tfont-size: 0.9375rem;\n\t\tline-height: 1.125rem;\n\t\tletter-spacing: 0.4px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary-black);\n\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.terms-button {\n\t\tion-button {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\twidth: 100px;\n\t\t\theight: 46px;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\t--box-shadow: none;\n\t\t\t--border-radius: 0;\n\t\t}\n\t}\n}\n\n.close-div {\n\tposition: absolute;\n\tright: 0.3125rem;\n\ttop: 0.3125rem;\n}\n\n::-webkit-scrollbar {\n\twidth: 0.625rem;\n}\n\n.close-icon {\n\tcursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
